export default {
    general: {
        GENERAL_ERROR: 'Error occurred. Please try again. If the error persists, contact support',
    },
    auth: {
        WRONG_PASSWORD: 'You have entered an incorrect password',
        COMPANY_NOT_ASSIGNED: "Account doesn't have company assigned. Contact admin",
    },
    accounts: {
        ACCOUNT_NOT_FOUND: 'Account not found',
        ACCOUNT_ALREADY_EXIST: 'Account email already exist',
        COMPANY_OWNER_ALREADY_ASSIGNED:
            'Given company owner already has assinged company. Try with another company owner!',
    },
    terminal: {
        TERMINAL_ALREADY_ASSIGNED: 'Terminal already assigned',
        DEVICE_ID_ALREADY_EXIST: 'Terminal with given device id already exists',
    },
    company: {
        COMPANY_ALREADY_EXISTS: 'Company with given ID number or VAT number already exists',
    },
    document: {
        SIZE_LIMIT: 'File size exceeds the maximum limit of 5MB',
        FILE_MISSING: 'Document is missing',
    },
    companyOwner: {
        PHONE_NUMBER_ALREADY_ASSIGNED: 'Phone number already assigned to another owner',
    },
    website: {
        WEBSITE_ALREADY_EXISTS: 'Domen already assigned',
    },
    products: {
        PRODUCT_ALREADY_EXISTS: 'Product with given name already exists',
        PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE: "Discounted prize shouldn't be equal or higher than price",
    },
    nestedProducts: {
        NESTED_PRODUCT_ALREADY_EXISTS: 'Nested product with given name already exists',
        NESTED_PRODUCT_DISCOUNTED_PRICE_GREATER_THAN_PRICE: "Discounted prize shouldn't be equal or higher than price",
    },
    productCategories: {
        PRODUCT_CATEGORY_ALREADY_EXISTS: 'Product category with given name already exists',
    },
    nestedProductCategories: {
        NESTED_PRODUCT_CATEGORY_ALREADY_EXISTS: 'Nested product category with given name already exists',
    },
    promotion: {
        PROMOTION_CATEGORY_ALREADY_EXISTS: 'Promotion with given name already exists',
        DISCOUNTED_PROMOTION_SHOULD_HAVE_DATE_RAGE: 'Discounted promotion must have start and end date',
        DISCOUNTED_PROMOTION_CANNOT_START_IN_PAST: 'Discounted promotion must not start in past',
        PRODUCT_ALREADY_IN_PROMOTION: 'One or more products are already in active promotion',
    },
    place: {
        SLUG_ALREDY_EXISTS: 'Place with given address alredy exists',
        NAME_IN_USE: 'Place with given name already exists',
    },
};
